import { getBillingAdminGrants } from '../redux/slices/organisation';
import { useAppDispatch, useAppSelector } from '../redux/store';

export const useOrganisationGrants = (organisationId: string) => {
	const dispatch = useAppDispatch();

	// Fetch the necessary state from Redux store
	const organisationGrants = useAppSelector((state) => state.organisation.billingAdminGrants);
	const readGrantsRequest = useAppSelector((state) => state.organisation.billingAdminGrantsRequest);

	// Define the `getGrants` function
	const getGrants = () => {
		// Dispatch the async action to fetch grants
		dispatch(getBillingAdminGrants({ organisationId }));
	};

	// Return the state and the getGrants function
	return { organisationGrants: organisationGrants?.Items?.[0], readGrantsRequest, getGrants };
};
